import logo from './logo.svg';
import Login from './components/Login/Login';
import Chat from './components/Chat/Chat';
import newChat from './components/NewChat/NewChat';
import {createStore, combineReducers} from 'redux';
import { HashRouter, Routes, Route, BrowserRouter } from "react-router-dom";
import './App.css';
import { Provider } from "react-redux";
import {Store} from './Redux/Store';
import React from 'react';
import Protected from './components/Protected';
import 'bootstrap/dist/css/bootstrap.min.css';


require('dotenv').config({ path: '/opt/skyelectric/.env/.env',debug: process.env.DEBUG });

console.log("process.env",process.env)
function App() {
  return (
    <div className="App">

   <Provider store={Store}>  
      <HashRouter>
        <Routes>
          <Route path="/" element={<Login />}/>
          <Route path="/chat" element={<Protected Component={Chat}/>} />
          <Route path="/newChat" element={<newChat />} />
        </Routes>
      </HashRouter>
    </Provider>


    

    </div>
  );
}

export default App;
